import cx from 'classnames';
import { enableProBotFeaturesV2 } from '../../constants/features';
import { MINIAPP_KEYS } from '../../constants/marketplace';
import { Platform } from '../../store/types';
import fonts from '../../styles/typography.module.scss';
import s from './SideMenu.module.scss';
import { BottomSection } from './components/BottomSection';
import { Controls } from './components/Controls';
import { SideMenuItem, SideMenuProps } from './components/SideMenuItem';
import { Top } from './components/Top';

const PREMIUN_MENU_ITEMS: SideMenuProps[] = [
  {
    title: 'Subscriptions',
    identifier: 'subscription',
    platforms: [Platform.Discord, Platform.Telegram],
    order: 1,
  },
  // {
  //   title: 'Guest Pass',
  //   identifier: 'guest-passes',
  //   platforms: [Platform.Discord],
  //   isPro: true,
  // },
  {
    title: 'Role Composition',
    identifier: 'role-composition',
    platforms: [Platform.Discord],
    order: 3,
  },
  {
    title: 'Community Analytics',
    identifier: 'analytics',
    platforms: [Platform.Discord],
    isPro: true,
    isFeatureAllowed: enableProBotFeaturesV2,
    order: 4,
  },
];

const CORE_MENU_ITEMS: SideMenuProps[] = [
  {
    title: 'Bot Config / Invite Link',
    identifier: 'config',
    platforms: [Platform.Telegram],
    customTrackingKey: 'bot-config-invite-link',
  },
  {
    title: 'Bot Config',
    identifier: 'config',
    platforms: [Platform.Discord],
    customTrackingKey: 'bot-config',
  },
  {
    title: 'Miniapps',
    identifier: 'marketplace',
    platforms: [Platform.Discord],
  },
  {
    title: 'Role Troubleshooting',
    identifier: 'rolesmanager',
    platforms: [Platform.Discord],
  },
  {
    title: 'TGRs & Plan Usage',
    identifier: 'tgrs',
    platforms: [Platform.Discord],
  },
  {
    title: 'Token Gated Access (TGA)',
    identifier: 'tgas',
    platforms: [Platform.Telegram],
  },
  {
    title: 'Snapshot',
    identifier: 'snapshot',
    platforms: [Platform.Discord],
    miniAppKey: MINIAPP_KEYS.SNAPSHOT,
  },
];

export const SideMenu = () => {
  const showSmartTag = true;

  const allPremiumItems: SideMenuProps[] = [
    ...PREMIUN_MENU_ITEMS,
    ...(showSmartTag
      ? [
          {
            title: 'SmartTag',
            identifier: 'smarttag',
            platforms: [Platform.Discord],
            isPro: false,
            badgeText: 'NEW',
            order: 2,
          },
        ]
      : []),
  ];
  const sortedPremiumItems = [...allPremiumItems].sort((a, b) => {
    const orderA = a.order || 999;
    const orderB = b.order || 999;
    return orderA - orderB;
  });
  const premiumMenuItems = sortedPremiumItems.map((props) => (
    <SideMenuItem key={props.identifier} {...props} />
  ));
  const coreMenuItems = CORE_MENU_ITEMS.map((props) => (
    <SideMenuItem key={props.identifier} {...props} />
  ));
  return (
    <>
      <div className={s.navigation}>
        <Top />
        {premiumMenuItems.length > 0 && (
          <>
            <p className={cx(s.title, fonts.caption1)}>Premium Services</p>{' '}
            {premiumMenuItems}
          </>
        )}
        {coreMenuItems.length > 0 && (
          <>
            <p className={cx(s.title, fonts.caption1)}>Collab.Land Core</p>{' '}
            {coreMenuItems}
          </>
        )}
      </div>
      <BottomSection />
      <Controls />
    </>
  );
};
